// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"check-double"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M2.10059 11.4141L7.05033 16.3638L7.40389 16.0103M16.2426 7.17139L12.3535 11.0605M21.8999 7.17139L12.7076 16.3638L7.75781 11.414","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const CheckDoubleIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'check-double',
    ref,
    icon: element,
  },
));

CheckDoubleIcon.displayName = 'CheckDoubleIcon';

export default CheckDoubleIcon;
